/**
 * Text selection icon
 */
export function TextSelectionIcon({ accessibilityLabel }: { readonly accessibilityLabel: string }) {
  const isDecorative = accessibilityLabel === ''
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={accessibilityLabel}
      aria-hidden={isDecorative}
      data-icon="TextSelection"
    >
      <rect width="16" height="16" rx="4.8" fill="#027E6F" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.80035 14.001H11.6C12.9255 14.001 14 12.9265 14 11.601V9.79959H12.8V11.601C12.8 12.2637 12.2627 12.801 11.6 12.801H9.80035V14.001ZM3.2 9.79959V11.601C3.2 12.2637 3.73726 12.801 4.4 12.801H6.20035V14.001H4.4C3.07452 14.001 2 12.9265 2 11.601V9.79959H3.2ZM6.20035 3.20098H4.4C3.73726 3.20098 3.2 3.73823 3.2 4.40098V6.19959H2V4.40098C2 3.07549 3.07452 2.00098 4.4 2.00098H6.20035V3.20098ZM12.8 6.19959V4.40098C12.8 3.73823 12.2627 3.20098 11.6 3.20098H9.80035V2.00098H11.6C12.9255 2.00098 14 3.07549 14 4.40098V6.19959H12.8Z"
        fill="white"
      />
      <path
        d="M5.59961 6.39941H7.99961H10.3996M5.59961 9.59941H7.09961H8.79961"
        stroke="white"
        strokeWidth="1.2"
      />
    </svg>
  )
}
